/**
 * Route guard for the admin area.
 *
 * Access: USER_MANAGER (80+) and SUPPORT (20) explicitly.
 * INSTRUCTOR (40) and CONTENT_MANAGER (60) are excluded.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import LoadingIcon from '@/foundation/ui/LoadingIcon';

const ADMIN_AREA_ROLES = new Set(['admin', 'user_manager', 'support']);

export function RequireAdminArea({ children }: { children: React.ReactNode }) {
  const { loading, role } = useAuth();

  if (loading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <LoadingIcon size="lg" />
      </div>
    );
  }

  if (!role || !ADMIN_AREA_ROLES.has(role.slug)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
